// @section: data-constants

export const COURSES_LIVE = [
  {
    id: 1,
    title: "Sintaxis para opositores — Nivel I",
    description: "Sesiones en directo con análisis de estructuras sintácticas complejas. Corrección de ejercicios en tiempo real.",
    date: "10 de julio de 2025",
    duration: "3 sesiones de 2 h",
    price: 120,
    spots: 18,
    tag: "Directo",
  },
  {
    id: 2,
    title: "Comentario de texto lingüístico — PAU",
    description: "Preparación intensiva para la prueba de acceso a la universidad con textos reales de convocatorias anteriores.",
    date: "17 de julio de 2025",
    duration: "2 sesiones de 3 h",
    price: 90,
    spots: 20,
    tag: "Directo",
  },
  {
    id: 3,
    title: "Morfología: teoría y práctica",
    description: "Revisión completa de la morfología española según la NGLE. Casos especiales y errores frecuentes.",
    date: "24 de julio de 2025",
    duration: "2 sesiones de 2 h",
    price: 80,
    spots: 15,
    tag: "Directo",
  },
];

export const COURSES_RECORDED = [
  {
    id: 4,
    title: "Sintaxis española — Nivel inicial",
    description: "Curso completo de análisis sintáctico desde los fundamentos hasta las estructuras complejas. A tu ritmo.",
    lessons: 24,
    duration: "18 h de contenido",
    price: 100,
    tag: "Grabado",
  },
  {
    id: 5,
    title: "Comentario de texto literario",
    description: "Metodología rigurosa para el análisis y comentario de textos literarios. Con ejemplos resueltos.",
    lessons: 18,
    duration: "14 h de contenido",
    price: 100,
    tag: "Grabado",
  },
  {
    id: 6,
    title: "Ortografía — Actualización docente",
    description: "Actualización completa según la última normativa de la RAE y la ASALE. Casos dudosos y criterios de corrección.",
    lessons: 12,
    duration: "8 h de contenido",
    price: 75,
    tag: "Grabado",
  },
];

export const MATERIALS_FREE = [
  {
    id: 1,
    title: "Dosier: Producción del texto argumentativo (PAU)",
    description: "Guía completa con modelos, criterios de corrección y textos de práctica para la PAU de Lengua.",
    type: "PDF",
    pages: 32,
    downloadCount: 1240,
  },
  {
    id: 2,
    title: "Cartas al director — Actividades competenciales",
    description: "Selección de cartas al director con propuestas de actividades para el aula de 4.º de ESO y Bachillerato.",
    type: "PDF",
    pages: 18,
    downloadCount: 890,
  },
  {
    id: 3,
    title: "Artículos de opinión — Día del Libro 2025",
    description: "Recopilación de artículos de opinión sobre el Día del Libro con actividades de comprensión lectora.",
    type: "PDF",
    pages: 24,
    downloadCount: 675,
  },
  {
    id: 4,
    title: "Esquema: Análisis morfológico paso a paso",
    description: "Tabla-guía para el análisis morfológico completo según los criterios de la NGLE (2019).",
    type: "PDF",
    pages: 4,
    downloadCount: 2100,
  },
];

export const BLOG_POSTS = [
  {
    id: 1,
    title: "DOSER producción de un texto argumentativo propio",
    excerpt: "Actualización del dosier para repasar la producción del texto argumentativo en la PAU. Incluye nuevos modelos y rúbricas de corrección.",
    date: "4 de junio de 2025",
    readTime: "5 min",
    category: "Recursos",
  },
  {
    id: 2,
    title: "Cartas al director y actividades competenciales",
    excerpt: "Nueva sección de comentario de texto: cartas al director con propuestas de actividades competenciales para el aula.",
    date: "30 de mayo de 2025",
    readTime: "4 min",
    category: "Actividades",
  },
  {
    id: 3,
    title: "Artículos de opinión para el Día del Libro",
    excerpt: "Recopilación de artículos de opinión en torno al Día del Libro con propuestas de actividades partiendo de estos textos.",
    date: "17 de mayo de 2025",
    readTime: "3 min",
    category: "Literatura",
  },
];

export const NAV_LINKS = [
  { label: "Inicio", href: "#inicio" },
  { label: "Cursos", href: "#cursos" },
  { label: "Materiales", href: "#materiales" },
  { label: "Blog", href: "#blog" },
  { label: "Sobre mí", href: "#sobre-mi" },
  { label: "Contacto", href: "#contacto" },
];
